import { get, writable } from "svelte/store";
import type { ActivityConfig } from "../declarations/config";

//TODO: Remove this before release
const getCurrentDate = () => {
  const isShowroom = false;
  if (isShowroom) {
    return 24;
  }

  const url = new URL(window.location.href);
  const fakeNow = url.searchParams.get("fakeNow");
  let currentDate: number;
  let currentMonth: number;
  let currentHour: number;
  let currentYear: number;

  if (fakeNow !== null) {
    const date = new Date(fakeNow);
    currentDate = date.getDate();
    currentMonth = date.getMonth() + 1;
    currentHour = date.getHours();
    currentYear = date.getFullYear();
  } else {
    const date = new Date();
    currentDate = date.getDate();
    currentMonth = date.getMonth() + 1;
    currentHour = date.getHours();
    currentYear = date.getFullYear();
  }
  if (currentYear > 2024) {
    currentDate = 24;
    return currentDate;
  }
  if (currentDate > 24 && currentMonth !== 11) {
    currentDate = 24;
  }
  if (currentMonth === 11 && currentDate === 30 && currentHour === 23) {
    currentDate = 1;
  } else if (currentMonth === 11) {
    currentDate = 0;
  }

  return currentDate;
};
export const BackgroundDimensions = writable({ width: 0, height: 0 });
export const CurrentDay = writable(getCurrentDate());

export const appStarted = writable(false);
export const assetsLoaded = writable(false);
export const assetsProgress = writable(0);
export const backgroundLoaded = writable(false);
export const isScrolling = writable(false);
export const isDragging = writable(false);
export const selectedActivityIndex = writable<null | number>(null);
export const selectedOtherActivity = writable<number | null>(null);
export const isOtherActivitiesWindowOpen = writable<boolean>(false);
export const mobileActivityIndex = writable<number>(get(CurrentDay));
export const todaysGiftOpened = writable<boolean>(false);
export const activitiesConfig = writable<ActivityConfig[]>([]);
export const urlParams = writable<URLSearchParams>(
  new URLSearchParams(window.location.search)
);

export const updateUrlParam = (param: string, value: string | null) => {
  const url = new URL(window.location.href);
  if (value !== null) {
    url.searchParams.set(param, value);
  } else {
    url.searchParams.delete(param);
  }
  urlParams.set(url.searchParams);
  window.history.replaceState(null, "", url); // or pushState
};

export const closedGiftSoundCounter = writable(0);
